import React from "react";

const CalendarIcon: React.FC = () => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33398 1.83325V3.83325"
        stroke="#4B5563"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.666 1.83325V3.83325"
        stroke="#4B5563"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33398 6.56006H13.6673"
        stroke="#4B5563"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 6.16659V11.8333C14 13.8333 13 15.1666 10.6667 15.1666H5.33333C3 15.1666 2 13.8333 2 11.8333V6.16659C2 4.16659 3 2.83325 5.33333 2.83325H10.6667C13 2.83325 14 4.16659 14 6.16659Z"
        stroke="#4B5563"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4625 9.63338H10.4685"
        stroke="#4B5563"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4625 11.6334H10.4685"
        stroke="#4B5563"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99764 9.63338H8.00363"
        stroke="#4B5563"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99764 11.6334H8.00363"
        stroke="#4B5563"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.52889 9.63338H5.53488"
        stroke="#4B5563"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.52889 11.6334H5.53488"
        stroke="#4B5563"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

export default CalendarIcon;
